/* =========================================================================
   gloofy - script.js  (mobile-first build)
   - daily countdown to midnight (auto-resets at 0:00)
   - scent / bundle / marquee / benefit rendering from one data source
   - mobile drawer menu + body scroll lock
   - cart counter + add-to-cart toast
   - sticky bottom CTA (mobile) shown after the hero scrolls out of view
   - newsletter submit
   ========================================================================= */

/* ---- BENEFITS: nur Fallback, falls die Section keine Blöcke hat (sonst gewinnt der Customizer) ---- */
const BENEFITS = [
  { num: "01", title: "kuschelweich & flauschig", desc: "ein extra-weicher plüsch, der sich beim ersten anfassen wie eine umarmung anfühlt – zum reinkuscheln und nicht mehr loslassen." },
  { num: "02", title: "mit der hand gefertigt", desc: "jeder bärli wird einzeln mit liebe genäht – sorgfältige nähte, liebevolle details, jeder ein unikat." },
  { num: "03", title: "sicher für die kleinsten", desc: "fest vernähte augen, keine scharfen kanten, hautfreundliche materialien – bedenkenlos auch für kinderhände." },
  { num: "04", title: "ein freund fürs leben", desc: "robust verarbeitet und waschbar – übersteht abenteuer, tränen und tausend umarmungen." },
  { num: "05", title: "ein geschenk, das bleibt", desc: "liebevoll verpackt – ein herzensgeschenk zur geburt, zum geburtstag oder einfach so." },
];

const PRICE = "13 €";

/* pricing model - whole euros only (no decimals), quantity-tiered bundle pricing.
   Gloofy Bundle-Stufen (max. 5 Bärlis):
     2 Bärlis - 20% Rabatt + gratis Versand
     3 Bärlis - + gratis Outfit
     4 Bärlis - 30% Rabatt
     5 Bärlis - + gratis Teddy */
const UNIT_COMPARE = 19;
const UNIT_PRICE   = 13;
const PRICE_TIERS  = [ { min: 8, unit: 10 }, { min: 5, unit: 11 }, { min: 1, unit: 13 } ];

const unitPriceFor = (q) => {
  for (const t of PRICE_TIERS) if (q >= t.min) return t.unit;
  return UNIT_PRICE;
};

const FREE_SHIP    = 40;
const BUNDLE_MAX   = 5;      // Bärlis bis zur letzten Stufe
const UPSELL_COMPARE = 64;
const UPSELL_PRICE   = 49;

const euro  = (n) => Math.round(n).toLocaleString("de-DE") + " €";  // suffix €, no decimals
const euroP = (n) => Math.round(n).toLocaleString("de-DE") + " €";  // € steht jetzt NACH der Zahl

/* ---- tiny helpers ---- */
const $ = (sel, ctx = document) => ctx.querySelector(sel);
const esc = (s) => String(s).replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c]));
const fmt = (n) => n.toLocaleString("de-DE");

/* ---- benefits ---- */
function renderBenefits() {
  const grid = $("#benefits-grid");
  if (!grid) return;

  // Wenn die Section bereits Blöcke aus dem Theme-Editor/Customizer enthält,
  // NICHT überschreiben — sonst würden die im Customizer gepflegten Texte durch
  // die alte hartcodierte Liste ersetzt. Nur als Fallback füllen, falls leer.
  if (!grid.querySelector(".benefit")) {
    grid.innerHTML = BENEFITS.map((b, i) => `
    <div class="benefit" style="--b-delay: ${i * 90}ms">
      <div class="benefit__num">${esc(b.num)}</div>
      <div class="benefit__body">
        <div class="benefit__title">${esc(b.title)}</div>
        <div class="benefit__desc">${esc(b.desc)}</div>
      </div>
      <svg class="benefit__chev" viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M9 6l6 6-6 6"/></svg>
    </div>`).join("");
  }

  // dezente Scroll-Einblendung der Zeilen
  const rows = grid.querySelectorAll(".benefit");
  if ("IntersectionObserver" in window) {
    const io = new IntersectionObserver((entries, obs) => {
      entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add("is-in"); obs.unobserve(e.target); } });
    }, { threshold: 0.25 });
    rows.forEach((r) => io.observe(r));
  } else {
    rows.forEach((r) => r.classList.add("is-in"));
  }
}

function startCountdown() {
  const el = $("#countdown");
  if (!el) return;
  const pad = (n) => String(n).padStart(2, "0");
  const tick = () => {
    const now = new Date();
    const end = new Date(now);
    end.setHours(24, 0, 0, 0); // next midnight
    let diff = Math.max(0, Math.floor((end - now) / 1000));
    el.textContent = `${pad(Math.floor(diff / 3600))} : ${pad(Math.floor((diff % 3600) / 60))} : ${pad(diff % 60)}`;
  };
  tick();
  setInterval(tick, 1000);
}

/* ---- cart state + toast ---- */
let cart = [];   // { id, key, variantId, name, qty, price, comparePrice, linePrice, image }
let toastTimer = null;
let _prev = { qty: 0, free: false, m5: false, m8: false };
let _lastAdded = null;

function showToast(msg) {
  const t = $("#toast");
  if (!t) return;
  t.textContent = msg;
  t.classList.add("is-visible");
  clearTimeout(toastTimer);
  toastTimer = setTimeout(() => t.classList.remove("is-visible"), 1900);
}

/* ---- Shopify AJAX Cart: schlanker fetch-Wrapper ---- */
async function shopifyCartRequest(url, options) {
  const res = await fetch(url, Object.assign({
    headers: { "Content-Type": "application/json", "Accept": "application/json" }
  }, options || {}));
  if (!res.ok) {
    let detail = "";
    try { detail = (await res.json()).description || ""; } catch (e) {}
    throw new Error(detail || ("Cart request failed: " + res.status));
  }
  return res.json();
}

function getCart() {
  return shopifyCartRequest("/cart.js", { method: "GET" });
}

/* ---- Rabattcode anwenden ---- */
let _appliedDiscount = null;
let _pendingDiscount = null;

function discountStatusFor(cartObj, code) {
  const wanted = (code || "").trim().toLowerCase();
  const list = cartObj && cartObj.discount_codes ? cartObj.discount_codes : [];
  const entry = list.find((d) => (d.code || "").toLowerCase() === wanted);
  if (!entry) return "absent";
  return entry.applicable ? "applicable" : "not_applicable";
}

async function clearDiscountCode() {
  const a = fetch("/discount/clear", { method: "GET", redirect: "manual" }).catch(() => {});
  const b = shopifyCartRequest("/cart/update.js", {
    method: "POST",
    body: JSON.stringify({ discount: "" })
  }).catch(() => {});
  await Promise.all([a, b]);
  _appliedDiscount = null;
}

async function applyDiscountCode(code, skipClear) {
  code = (code || "").trim();
  if (!code) return { ok: false, reason: "empty" };
  
  if (!skipClear) await clearDiscountCode();
  
  try {
    await fetch("/discount/" + encodeURIComponent(code), { method: "GET", redirect: "manual" });
  } catch (e) {}
  
  const c = await getCart();
  const status = discountStatusFor(c, code);
  
  if (status === "applicable") {
    const discountValue = c.total_discount || 0;
    _appliedDiscount = { code: code, value: discountValue };
    mapShopifyCartItems(c);
    computeCartTotals();
    return { ok: true, value: discountValue, cart: c };
  }
  
  await clearDiscountCode();
  const fresh = await getCart();
  mapShopifyCartItems(fresh);
  computeCartTotals();
  return { ok: false, reason: status === "not_applicable" ? "not_applicable" : "invalid", cart: fresh };
}

/* ---- Config ---- */
const BUNDLE_CFG = { enabled: true, p10: "", ship: "", p20: "", bonus: "", excludeIds: [] };
let _bundleCodesLc = new Set();

function readBundleConfig() {
  const el = document.getElementById("gloofy-bundle-cfg");
  if (!el) return;
  let cfg = {};
  try { cfg = JSON.parse(el.textContent || "{}"); } catch (e) { return; }
  BUNDLE_CFG.enabled = cfg.enabled !== false;
  BUNDLE_CFG.p10   = (cfg.code10    || "").trim();
  BUNDLE_CFG.ship  = (cfg.codeShip  || "").trim();
  BUNDLE_CFG.p20   = (cfg.code20    || "").trim();
  BUNDLE_CFG.bonus = (cfg.codeBonus || "").trim();
  BUNDLE_CFG.excludeIds = String(cfg.excludeIds || "")
    .split(/[\s,]+/).map((s) => s.trim()).filter(Boolean);
  
  _bundleCodesLc = new Set(
    [BUNDLE_CFG.p10, BUNDLE_CFG.ship, BUNDLE_CFG.p20, BUNDLE_CFG.bonus]
      .filter(Boolean).map((c) => c.toLowerCase())
  );
}

function qualifyingQty() {
  if (!BUNDLE_CFG.excludeIds.length) return cartQty();
  const ex = new Set(BUNDLE_CFG.excludeIds.map(String));
  return cart.reduce((n, i) => n + (ex.has(String(i.variantId)) ? 0 : i.qty), 0);
}

/* ---- PERFORMANCE & ROBUSTHEIT ---- */
let _cartOpChain = Promise.resolve();
function queueCartOp(fn) {
  const run = _cartOpChain.then(fn, fn);
  _cartOpChain = run.catch(() => {});
  return run;
}

let _pendingOps = 0;
let _lastServerCart = null;

function enqueueWrite(doWrite) {
  _pendingOps++;
  return queueCartOp(async () => {
    try {
      const c = await doWrite();
      if (c) _lastServerCart = c;
    } catch (err) {
      console.error("gloofy cart write error:", err);
      showToast("warenkorb konnte nicht aktualisiert werden");
    } finally {
      _pendingOps--;
      if (_pendingOps === 0) {
        const hasPendingDesire = Object.keys(_desiredQty).length > 0;
        if (!hasPendingDesire) {
          try {
            await applyServerCart(_lastServerCart || (await getCart()));
          } catch (e) { console.error("gloofy finalize error:", e); }
          _lastServerCart = null;
        }
      }
    }
  });
}

function cartAdd(variantId, quantity, sellingPlan) {
  var item = { id: variantId, quantity: quantity || 1 };
  if (sellingPlan) item.selling_plan = sellingPlan;
  return shopifyCartRequest("/cart/add.js", {
    method: "POST",
    body: JSON.stringify({ items: [item] })
  });
}

function cartChange(key, quantity) {
  return shopifyCartRequest("/cart/change.js", {
    method: "POST",
    body: JSON.stringify({ id: key, quantity: Number(quantity) })
  });
}

function mapShopifyCartItems(shopifyCart) {
  const prevByKey = Object.create(null);
  const prevOrder = [];
  for (const it of cart) { prevByKey[it.key] = it; prevOrder.push(it.key); }

  const mapped = Object.create(null);
  for (const i of shopifyCart.items) {
    const hasPending = i.key in _desiredQty;
    // Zwingend den vom Nutzer gewünschten _desiredQty Wert nutzen!
    const qty = hasPending ? _desiredQty[i.key] : i.quantity;
    
    // Wenn die Menge 0 ist (wurde gerade gelöscht), ignorieren wir das Item
    if (qty <= 0) continue; 

    const unit = i.final_price;
    const unitCompare = i.original_price;
    const linePrice = hasPending ? unit * qty : i.final_line_price;
    const compareLinePrice = hasPending ? unitCompare * qty : i.original_line_price;
    
    mapped[i.key] = {
      id: i.variant_id, key: i.key, variantId: i.variant_id,
      name: i.product_title || i.title, qty: qty,
      price: unit, comparePrice: unitCompare,
      linePrice: linePrice, compareLinePrice: compareLinePrice,
      image: i.image
    };
  }

  const result = [];
  const used = new Set();
  for (const key of prevOrder) {
    if (mapped[key]) { result.push(mapped[key]); used.add(key); }
  }
  for (const i of shopifyCart.items) {
    if (!used.has(i.key)) { result.push(mapped[i.key]); used.add(i.key); }
  }
  cart = result;
}

function cartQty() { return cart.reduce((n, i) => n + i.qty, 0); }

/* ---- HARCODED RABATT LOGIK ---- */
let _shopifyCartTotal = 0;          // in Cent, final (nach evtl. Rabatten)
let _shopifyCartOriginalTotal = 0;  // in Cent, vor Rabatten

function getHardcodedDiscountPercent(qty) {
  if (qty >= 4) return 0.30; // ab 4 Stück: 30% Rabatt
  if (qty >= 2) return 0.20; // 2–3 Stück: 20% Rabatt
  return 0.00;               // 0% Rabatt
}

function computeCartTotals() {
  // Gesamtsumme = Summe der tatsächlich angezeigten Zeilenpreise (Preis neben dem Produkt).
  // Ersparnis ("Du sparst") = Differenz zwischen dem durchgestrichenen Vergleichspreis
  // und dem echten Preis, aufsummiert über alle Positionen. Beispiel: 196 € durchgestrichen,
  // 137 € echt -> Du sparst 59 €.
  let total = 0;
  let original = 0;
  cart.forEach(i => {
    const line = (typeof i.linePrice === "number") ? i.linePrice : (i.price * i.qty);
    // Vergleichspreis nur werten, wenn er höher ist als der echte Preis
    const comp = (typeof i.compareLinePrice === "number" && i.compareLinePrice > line)
      ? i.compareLinePrice : line;
    total += line;
    original += comp;
  });
  _shopifyCartOriginalTotal = original;
  _shopifyCartTotal = total;
}

function cartTotal() { return _shopifyCartTotal / 100; }
function cartSavings() { return Math.max(0, (_shopifyCartOriginalTotal - _shopifyCartTotal) / 100); }

/* ---- Bundle-Fortschritt (Gloofy: 4 Stufen, max. 5 Bärlis) ---- */
const MS = [
  { q: 2, bis: "bis 20% Rabatt",                  done: "20% Rabatt" },
  { q: 3, bis: "bis zum gratis Outfit",           done: "Gratis Outfit" },
  { q: 4, bis: "bis 30% Rabatt",                  done: "30% Rabatt" },
  { q: 5, bis: "bis zu deinem gratis Teddy",      done: "Gratis Teddy" },
];
const BP_CHECK = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"><path d="M20 6 9 17l-5-5"/></svg>';

function bpFill(qty) {
  // Knoten liegen bei 2,3,4,5 (siehe Markup-Positionen 8/36/64/92%)
  const stops = [[1, 0], [2, 8], [3, 36], [4, 64], [5, 92]];
  if (qty <= 1) return 0;
  if (qty >= 5) return 100;
  for (let i = 0; i < stops.length - 1; i++) {
    const [q0, p0] = stops[i], [q1, p1] = stops[i + 1];
    if (qty >= q0 && qty <= q1) return p0 + ((qty - q0) / (q1 - q0)) * (p1 - p0);
  }
  return 100;
}

function bpNextThreshold(qty) {
  const m = MS.find((x) => x.q > qty);
  return m ? m.q : null;
}

function bundleTexts(qty) {
  const next = MS.find((m) => m.q > qty);
  let hook;
  if (!next) {
    hook = '<strong>Alles freigeschaltet</strong> 🧸 30% Rabatt, gratis Outfit, gratis Versand &amp; ein gratis Teddy!';
  } else {
    const rem = next.q - qty;
    const baerli = rem === 1 ? "1 Bärli" : rem + " Bärlis";
    hook = 'Nur noch <strong>' + baerli + '</strong> ' + next.bis + '.';
  }
  let done = null;
  for (const m of MS) if (qty >= m.q) done = m;
  let success;
  if (!next) success = "Gratis Outfit, gratis Versand &amp; ein gratis Teddy inklusive 🧸";
  else success = done ? done.done + " freigeschaltet." : "";
  return { hook, success };
}

let _bpUnlocked = new Set();
let _bpInit = false;

function renderBundleProgress(qty) {
  const bp = document.getElementById("bp");
  if (!bp) return;
  const fill = document.getElementById("bp-fill");
  if (fill) fill.style.width = bpFill(qty) + "%";
  
  const nextQ = bpNextThreshold(qty);
  bp.querySelectorAll("[data-q]").forEach((el) => {
    const q = parseInt(el.dataset.q, 10);
    const unlocked = qty >= q;
    const isNext = !unlocked && q === nextQ;
    el.classList.toggle("is-unlocked", unlocked);
    el.classList.toggle("is-next", isNext);
    
    if (unlocked && _bpInit && !_bpUnlocked.has(q)) {
      popEl(el.querySelector(".bp__dot, .bp__bubble"));
    }
    if (unlocked) _bpUnlocked.add(q); else _bpUnlocked.delete(q);
    
    const hint = el.querySelector(".bp__reward-hint");
    if (hint) {
      if (isNext) {
        const rem = q - qty;
        hint.textContent = "nur noch " + rem + (rem === 1 ? " Bärli" : " Bärlis");
      } else {
        hint.textContent = "";
      }
    }
  });
  
  const t = bundleTexts(qty);
  const hookEl = document.getElementById("bp-hook");
  if (hookEl) hookEl.innerHTML = t.hook;
  const sucEl = document.getElementById("bp-success");
  if (sucEl) {
    if (t.success) { sucEl.innerHTML = BP_CHECK + "<span>" + t.success + "</span>"; sucEl.hidden = false; }
    else { sucEl.innerHTML = ""; sucEl.hidden = true; }
  }
  renderStickyMini(qty);
  _bpInit = true;
}

const MS_SHORT = { 2: "20% Rabatt", 3: "Gratis Outfit", 4: "30% Rabatt", 5: "Gratis Teddy" };
const MINI_P = [0, 33.33, 66.67, 100];

function miniFillPct(qty) {
  if (qty >= 5) return 100;
  if (qty <= 1) return qty <= 0 ? 0 : 4;
  const nextIdx = MS.findIndex((m) => m.q > qty);
  if (nextIdx === -1) return 100;
  const last = nextIdx - 1;
  return last >= 0 ? MINI_P[last] : 4;
}

function renderStickyMini(qty) {
  const bps = document.getElementById("bps");
  if (!bps) return;
  const fill = document.getElementById("bps-fill");
  if (fill) fill.style.width = miniFillPct(qty) + "%";
  
  const nextQ = bpNextThreshold(qty);
  bps.querySelectorAll("[data-q]").forEach((el) => {
    const q = parseInt(el.dataset.q, 10);
    const unlocked = qty >= q;
    el.classList.toggle("is-unlocked", unlocked);
    el.classList.toggle("is-next", !unlocked && q === nextQ);
  });
  
  const txtEl = document.getElementById("bps-text");
  if (txtEl) {
    const next = MS.find((m) => m.q > qty);
    if (!next) {
      txtEl.innerHTML = '<span class="bps__ok">' + BP_CHECK + "</span>Alles freigeschaltet 🧸";
    } else {
      const rem = next.q - qty;
      const baerli = rem === 1 ? "1 Bärli" : rem + " Bärlis";
      let done = null;
      for (const m of MS) if (qty >= m.q) done = m;
      const prefix = done ? '<span class="bps__ok">' + BP_CHECK + "</span>" : "";
      txtEl.innerHTML = prefix + "Noch <strong>" + baerli + "</strong> bis " + MS_SHORT[next.q];
    }
  }
}

function renderCart() {
  const qty = cartQty();
  const total = cartTotal();
  
  const badge = $("#cart-count"); if (badge) { badge.textContent = qty; badge.classList.toggle("is-empty", qty === 0); }
  const qEl = $("#cart-qty"); if (qEl) qEl.textContent = qty;
  
  renderBundleProgress(qualifyingQty());
  
  const savings = cartSavings();
  const saveEl = $("#cart-save"); if (saveEl) saveEl.textContent = "-" + euroP(savings);
  const saveRow = $("#cart-save-row"); if (saveRow) saveRow.classList.toggle("is-saving", savings > 0);
  const freeShipRow = $("#cart-freeship-row"); if (freeShipRow) freeShipRow.hidden = qualifyingQty() < 2;
  const totEl  = $("#cart-total"); if (totEl)  { totEl.textContent = euroP(total); }
  
  const scrollEl = document.querySelector(".cart__scroll");
  const savedScroll = scrollEl ? scrollEl.scrollTop : 0;
  const wrap = $("#cart-items");
  
  if (wrap) {
    if (cart.length === 0) {
      wrap.innerHTML = `<div class="cart__empty">dein warenkorb ist noch leer.</div>`;
    } else {
      const empty = wrap.querySelector(".cart__empty");
      if (empty) empty.remove();
      const seen = new Set();
      let prevNode = null;
      cart.forEach((i) => {
        seen.add(i.key);
        let ci = wrap.querySelector(`.ci [data-inc="${i.key}"]`);
        ci = ci ? ci.closest(".ci") : null;
        if (!ci) {
          ci = document.createElement("div");
          ci.className = "ci" + (i.key === _lastAdded ? " ci--in" : "");
          ci.innerHTML = `
            <div class="ci__thumb"><img src="${i.image || ""}" alt=""></div>
            <div class="ci__body">
              <div class="ci__name">${esc(i.name)}</div>
              <div class="ci__qty">
                <button data-dec="${i.key}" aria-label="weniger">\u2212</button>
                <span>${i.qty}</span>
                <button data-inc="${i.key}" aria-label="mehr">+</button>
              </div>
            </div>
            <div class="ci__side">
              <button class="ci__remove" data-remove="${i.key}" aria-label="entfernen">
                <svg viewBox="0 0 24 24" width="14" height="14" fill="none" stroke="currentColor" stroke-width="1.7" stroke-linecap="round" stroke-linejoin="round"><path d="M4 7h16M9 7V5h6v2M7 7l1 13h8l1-13"/></svg>
              </button>
              <div class="ci__price"></div>
            </div>`;
        } else {
          const qs = ci.querySelector(".ci__qty span");
          if (qs && qs.textContent != i.qty) qs.textContent = i.qty;
        }
        
        const priceBox = ci.querySelector(".ci__price");
        if (priceBox) {
          const strike = i.compareLinePrice > i.linePrice ? `<span class="strike">${euroP(i.compareLinePrice / 100)}</span>` : "";
          const html = strike + `<strong>${euroP(i.linePrice / 100)}</strong>`;
          if (priceBox.innerHTML !== html) priceBox.innerHTML = html;
        }
        
        const anchor = prevNode ? prevNode.nextSibling : wrap.firstChild;
        if (ci !== anchor) wrap.insertBefore(ci, anchor);
        prevNode = ci;
      });
      
      wrap.querySelectorAll(".ci").forEach((node) => {
        const incBtn = node.querySelector("[data-inc]");
        const key = incBtn ? incBtn.dataset.inc : null;
        if (key && !seen.has(key)) node.remove();
      });
    }
  }
  
  if (scrollEl) scrollEl.scrollTop = savedScroll;
  _lastAdded = null;
  _prev = { qty };
  renderUpsell();
  syncPromoUI();
}

function syncPromoUI() {
  const form = document.getElementById("cart-promo");
  if (!form) return;
  const input = document.getElementById("promo-input");
  const btn = document.getElementById("promo-btn");
  const msg = document.getElementById("promo-msg");
  
  if (input && document.activeElement === input) return;
  
  const setMsg = (text, ok) => {
    if (!msg) return;
    msg.textContent = text;
    msg.classList.toggle("is-ok", !!ok);
    msg.classList.toggle("is-err", !ok);
    msg.hidden = false;
  };
  
  if (_appliedDiscount && _appliedDiscount.code) {
    const wasActive = form.classList.contains("is-active");
    form.classList.remove("is-invalid");
    form.classList.add("is-active");
    if (input && !input.value.trim()) input.value = _appliedDiscount.code.toUpperCase();
    if (btn) btn.textContent = "aktiv";
    const msgVisible = msg && !msg.hidden;
    if (!wasActive || msgVisible) {
      setMsg("code  " + _appliedDiscount.code.toUpperCase() + "  angewendet.", true);
    }
  } else {
    form.classList.remove("is-active");
    if (btn) btn.textContent = "einlösen";
    if (msg && msg.classList.contains("is-ok")) msg.hidden = true;
  }
}

async function applyServerCart(shopifyCart) {
  mapShopifyCartItems(shopifyCart);
  
  if (_pendingDiscount && cartQty() > 0) {
    const already = (shopifyCart.discount_codes || []).some(
      (d) => d.applicable && d.code.toLowerCase() === _pendingDiscount.toLowerCase()
    );
    if (!already) {
      try {
        await fetch("/discount/" + encodeURIComponent(_pendingDiscount), { method: "GET", redirect: "manual" });
        shopifyCart = await getCart();
        mapShopifyCartItems(shopifyCart);
      } catch (e) {}
    }
  }

  // Hardcodierte Summen berechnen statt fehlerhafter Shopify-Code Abfrage
  computeCartTotals();
  
  const applicableCodes = (shopifyCart.discount_codes || [])
    .filter((d) => d.applicable && !_bundleCodesLc.has((d.code || "").toLowerCase()));
  
  if (applicableCodes.length > 0) {
    _appliedDiscount = { code: applicableCodes[0].code, value: shopifyCart.total_discount || 0 };
    _pendingDiscount = null;
  } else {
    _appliedDiscount = null;
    if (_pendingDiscount && cartQty() > 0) _pendingDiscount = null;
  }

  renderCart();
  return shopifyCart;
}

async function syncCartFromShopify() {
  try {
    const shopifyCart = await getCart();
    return await applyServerCart(shopifyCart);
  } catch (err) {
    console.error("gloofy cart sync error:", err);
    showToast("warenkorb konnte nicht geladen werden");
  }
}

function popEl(el) {
  if (!el) return;
  el.classList.remove("pop");
  void el.offsetWidth;
  el.classList.add("pop");
}

function renderUpsell() {
  const box = $("#upsell");
  if (!box) return;
  
  let candidates = document.querySelectorAll("#scents-grid .add");
  if (!candidates.length) candidates = document.querySelectorAll("#swatches .swatch-card[data-id]");
  if (!candidates.length) candidates = document.querySelectorAll("#mm-grid [data-pick]");
  
  let pick = null;
  for (const btn of candidates) {
    const variantId = btn.dataset.id || btn.dataset.pick;
    if (variantId && !cart.some((i) => String(i.variantId) === String(variantId))) { pick = btn; break; }
  }
  
  if (!pick) { box.hidden = true; box.dataset.id = ""; return; }
  box.hidden = false;
  const newId = pick.dataset.id || pick.dataset.pick;
  if (box.dataset.id === String(newId)) return;
  box.dataset.id = newId;
  
  const name = $("#upsell-name"); if (name) name.textContent = pick.dataset.name || "";
  const thumb = $("#upsell-thumb"); if (thumb) { thumb.innerHTML = `<img src="${pick.dataset.img || ""}" alt="">`; }
  const price = $("#upsell-price"); if (price) price.textContent = euro(UPSELL_PRICE);
  const strike = box.querySelector(".upsell__prices .strike"); if (strike) strike.textContent = euro(UPSELL_COMPARE);
}

function addItem(id, name, n, sellingPlan) {
  n = n || 1;
  if (!id) return;
  openCart();
  return enqueueWrite(async () => {
    const addResp = await cartAdd(id, n, sellingPlan);
    const addedLine = addResp && addResp.items ? addResp.items[0] : addResp;
    if (_pendingOps === 1 && addedLine && addedLine.key) {
      _lastAdded = addedLine.key;
      const existing = cart.find((i) => i.key === addedLine.key);
      if (existing) {
        applyOptimisticQty(addedLine.key, existing.qty + (addedLine.quantity || n));
      } else {
        const lp = addedLine.final_line_price != null ? addedLine.final_line_price : (addedLine.line_price || 0);
        const olp = addedLine.original_line_price != null ? addedLine.original_line_price : lp;
        cart.push({
          id: addedLine.variant_id,
          key: addedLine.key,
          variantId: addedLine.variant_id,
          name: addedLine.product_title || addedLine.title || (name || ""),
          qty: addedLine.quantity || n,
          price: addedLine.final_price != null ? addedLine.final_price : addedLine.price,
          comparePrice: addedLine.original_price != null ? addedLine.original_price : addedLine.price,
          linePrice: lp,
          compareLinePrice: olp,
          image: addedLine.image || ""
        });
        computeCartTotals();
      }
      renderCart();
    }
    // Kein Toast mehr beim Hinzufügen — der Warenkorb öffnet sich bereits als Bestätigung.
    return null;
  });
}

function applyOptimisticQty(key, newQty) {
  const line = cart.find((i) => i.key === key);
  if (!line) return;
  const target = Math.max(0, newQty);
  if (target <= 0) {
    cart = cart.filter((i) => i.key !== key);
  } else {
    line.qty = target;
    if (typeof line.linePrice === "number") line.linePrice = line.price * target;
    if (typeof line.compareLinePrice === "number") {
      line.compareLinePrice = (line.comparePrice || line.price) * target;
    }
  }
  // UPDATE TOTALS DYNAMICALLY - LÖST DEN BUG BEIM REDUZIEREN DER MENGE
  computeCartTotals();
}

let _desiredQty = Object.create(null);
let _qtyWriteScheduled = Object.create(null);

function flushQtyWrite(key) {
  enqueueWrite(async () => {
    const q = key in _desiredQty ? _desiredQty[key] : null;
    _qtyWriteScheduled[key] = false;
    if (q === null) return null;
    try {
      const result = await cartChange(key, q);
      return result;
    } finally {
      if (_desiredQty[key] === q) delete _desiredQty[key];
    }
  });
}

function changeQty(key, delta) {
  const line = cart.find((i) => i.key === key);
  if (!line) return;
  const target = Math.max(0, line.qty + delta);
  if (target <= 0) { removeItem(key); return; }
  applyOptimisticQty(key, target);
  _lastAdded = null;
  renderCart();
  _desiredQty[key] = target;
  if (!_qtyWriteScheduled[key]) {
    _qtyWriteScheduled[key] = true;
    flushQtyWrite(key);
  }
}

function removeItem(key) {
  const line = cart.find((i) => i.key === key);
  if (!line) return;
  applyOptimisticQty(key, 0);
  _lastAdded = null;
  renderCart();
  _desiredQty[key] = 0;
  if (!_qtyWriteScheduled[key]) {
    _qtyWriteScheduled[key] = true;
    flushQtyWrite(key);
  }
}

function openCart() {
  const c = $("#cart"); if (!c) return;
  const wasOpen = c.classList.contains("is-open");
  c.hidden = false;
  void c.offsetWidth;
  c.classList.add("is-open");
  document.body.style.overflow = "hidden";
  if (!wasOpen) document.dispatchEvent(new CustomEvent("gloofy:cart-opened"));
}

function closeCart() {
  const c = $("#cart"); if (!c) return;
  c.classList.remove("is-open");
  document.body.style.overflow = "";
  setTimeout(() => { c.hidden = true; }, 300);
}

function setupCartStickyProgress() {
  const scroll = document.querySelector(".cart__scroll");
  const bp = document.getElementById("bp");
  const bps = document.getElementById("bps");
  if (!scroll || !bp || !bps || !("IntersectionObserver" in window)) return;
  const io = new IntersectionObserver((entries) => {
    const e = entries[0];
    const show = !e.isIntersecting;
    bps.classList.toggle("is-visible", show);
    bps.setAttribute("aria-hidden", show ? "false" : "true");
  }, { root: scroll, threshold: 0 });
  io.observe(bp);
  document.addEventListener("gloofy:cart-opened", () => {
    scroll.scrollTop = 0;
    bps.classList.remove("is-visible");
    bps.setAttribute("aria-hidden", "true");
  });
}

function setupDrawer() {
  const burger = $("#burger");
  const drawer = $("#drawer");
  if (!burger || !drawer) return;
  const open = () => {
    drawer.hidden = false;
    void drawer.offsetWidth;
    drawer.classList.add("is-open");
    burger.setAttribute("aria-expanded", "true");
    document.body.style.overflow = "hidden";
  };
  const close = () => {
    drawer.classList.remove("is-open");
    burger.setAttribute("aria-expanded", "false");
    document.body.style.overflow = "";
    setTimeout(() => { drawer.hidden = true; }, 300);
  };
  burger.addEventListener("click", open);
  drawer.addEventListener("click", (e) => { if (e.target.closest("[data-drawer-close]")) close(); });
  document.addEventListener("keydown", (e) => { if (e.key === "Escape" && !drawer.hidden) close(); });
}

function setupStickyCta() {
  const cta = $("#sticky-cta");
  const hero = $(".hero");
  if (!cta || !hero || !("IntersectionObserver" in window)) return;
  const footer = document.querySelector(".footer");
  let heroPassed = false;   // Hero rausgescrollt?
  let footerSeen = false;   // Footer erreicht?

  const setPad = () => {
    document.documentElement.style.setProperty(
      "--sticky-h",
      cta.classList.contains("is-visible") ? cta.offsetHeight + "px" : "0px"
    );
  };
  const update = () => {
    // Sichtbar nur, wenn Hero vorbei UND Footer noch nicht erreicht (und mobil)
    const show = heroPassed && !footerSeen && window.innerWidth < 1040;
    cta.classList.toggle("is-visible", show);
    setPad();
  };

  const heroIo = new IntersectionObserver(([entry]) => {
    heroPassed = !entry.isIntersecting;
    update();
  }, { rootMargin: "-60px 0px 0px 0px" });
  heroIo.observe(hero);

  // Footer: sobald er ins Bild kommt, Sticky-Bar ausblenden
  if (footer) {
    const footIo = new IntersectionObserver(([entry]) => {
      footerSeen = entry.isIntersecting;
      update();
    }, { rootMargin: "0px 0px 0px 0px" });
    footIo.observe(footer);
  }
}

function bindEvents() {
  document.addEventListener("click", (e) => {
    const add = e.target.closest(".add");
    if (add) { addItem(add.dataset.id, add.dataset.name); return; }
    if (e.target.closest("[data-cart-open]")) { openCart(); return; }
    if (e.target.closest("[data-cart-close]")) { closeCart(); return; }
    const inc = e.target.closest("[data-inc]");
    if (inc) { changeQty(inc.dataset.inc, +1); return; }
    const dec = e.target.closest("[data-dec]");
    if (dec) { changeQty(dec.dataset.dec, -1); return; }
    const rem = e.target.closest("[data-remove]");
    if (rem) { removeItem(rem.dataset.remove); return; }
    if (e.target.closest("#upsell-add")) {
      const box = $("#upsell");
      if (box && box.dataset.id) addItem(box.dataset.id);
      return;
    }
    if (e.target.closest("#cart-checkout")) {
      // Rabattcode nur anhängen, wenn im Customizer wirklich einer hinterlegt ist.
      // Bei automatischen Rabatten (empfohlen) bleibt der Code leer -> Shopify
      // rechnet den Rabatt am Checkout selbst, passend zur Warenkorb-Anzeige.
      const q = qualifyingQty();
      let code = "";
      if (q >= 4) code = BUNDLE_CFG.p20 || BUNDLE_CFG.p10;   // 30%-Stufe
      else if (q >= 2) code = BUNDLE_CFG.p10;                 // 20%-Stufe
      code = (code || "").trim();
      
      const goCheckout = () => { 
        window.location.href = code ? `/checkout?discount=${encodeURIComponent(code)}` : "/checkout"; 
      };
      _cartOpChain.then(goCheckout, goCheckout);
      return;
    }
  });

  const promoForm = $("#cart-promo");
  if (promoForm) {
    const input = $("#promo-input");
    const btn = $("#promo-btn");
    const msg = $("#promo-msg");
    const showMsg = (text, ok) => {
      if (!msg) return;
      msg.textContent = text;
      msg.classList.toggle("is-ok", !!ok);
      msg.classList.toggle("is-err", !ok);
      msg.hidden = false;
    };
    
    promoForm.addEventListener("submit", async (e) => {
      e.preventDefault();
      const code = (input.value || "").trim();
      promoForm.classList.remove("is-invalid", "is-active");
      
      if (!code) {
        if (_appliedDiscount || _pendingDiscount) {
          btn.disabled = true;
          _pendingDiscount = null;
          await clearDiscountCode();
          await syncCartFromShopify();
          btn.disabled = false;
          btn.textContent = "einlösen";
          if (msg) { showMsg("rabattcode entfernt.", true); }
          const saveEl = $("#cart-save"); if (saveEl) popEl(saveEl);
          const totEl = $("#cart-total"); if (totEl) popEl(totEl);
        } else {
          btn.classList.remove("nudge"); void btn.offsetWidth; btn.classList.add("nudge");
        }
        return;
      }
      btn.disabled = true;
      const original = btn.textContent;
      btn.textContent = "…";
      
      try {
        if (cartQty() === 0) {
          try {
            await fetch("/discount/" + encodeURIComponent(code), { method: "GET", redirect: "manual" });
          } catch (e) {}
          _pendingDiscount = code;
          btn.textContent = original;
          promoForm.classList.remove("is-invalid", "is-active");
          showMsg("code vorgemerkt – füge produkte hinzu, dann wird er angewendet.", true);
          if (input && !input.value.trim()) input.value = code.toUpperCase();
          return;
        }
        const res = await applyDiscountCode(code);
        if (res.ok) {
          promoForm.classList.add("is-active");
          btn.textContent = "aktiv";
          showMsg("code '" + code.toUpperCase() + "' angewendet.", true);
          renderCart();
          const saveEl = $("#cart-save"); if (saveEl) popEl(saveEl);
          const totEl = $("#cart-total"); if (totEl) popEl(totEl);
        } else {
          btn.textContent = original;
          promoForm.classList.remove("is-invalid"); void promoForm.offsetWidth;
          promoForm.classList.add("is-invalid");
          renderCart();
          showMsg(res.reason === "not_applicable"
            ? "code gilt für diesen warenkorb nicht."
            : "dieser code ist leider ungültig.", false);
        }
      } catch (err) {
        btn.textContent = original;
        promoForm.classList.add("is-invalid");
        showMsg("code konnte nicht geprüft werden.", false);
      } finally {
        btn.disabled = false;
      }
    });
    
    if (input) {
      input.addEventListener("input", () => {
        promoForm.classList.remove("is-invalid");
        const active = _appliedDiscount ? _appliedDiscount.code.toUpperCase() : null;
        const typed = input.value.trim().toUpperCase();
        if (promoForm.classList.contains("is-active") && active && typed !== active) {
          promoForm.classList.remove("is-active");
          if (btn) btn.textContent = "einlösen";
          if (msg) {
            if (typed === "") {
              showMsg("… einlösen drücken, um den code zu entfernen.", true);
            } else {
              msg.hidden = true;
            }
          }
        }
      });
    }
    
    let nudgeTimer;
    document.addEventListener("gloofy:cart-opened", () => {
      clearTimeout(nudgeTimer);
      nudgeTimer = setTimeout(() => {
        if (!promoForm.classList.contains("is-active") && btn && (!input || !input.value.trim())) {
          btn.classList.remove("nudge"); void btn.offsetWidth; btn.classList.add("nudge");
        }
      }, 2600);
    });
  }

  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") closeCart();
  });

  const form = $("#newsletter-form");
  if (form) {
    form.addEventListener("submit", (e) => {
      e.preventDefault();
      form.reset();
      showToast("willkommen in der gloofy family ♥");
    });
  }
}

function initProductPage() {
  const root = document.querySelector(".pdp") || document.querySelector(".pdp__top");
  if (!root) return;
  let qty = 1;

  function currentSellingPlan() {
    const pick = document.querySelector("#purchase-pick .pseg__opt.is-active");
    const val = pick ? (pick.dataset.sellingPlan || "") : "";
    return val || null;
  }

  function setPurchaseMode(activeCard) {
    const pick = document.getElementById("purchase-pick");
    if (!pick || !activeCard) return;
    const opts = Array.prototype.slice.call(pick.querySelectorAll(".pseg__opt"));
    opts.forEach((c) => {
      const on = c === activeCard;
      c.classList.toggle("is-active", on);
      c.setAttribute("aria-pressed", on ? "true" : "false");
    });
    const isRight = opts.indexOf(activeCard) === 1;
    pick.classList.toggle("is-right", isRight);
    
    const plan = activeCard.dataset.sellingPlan || "";
    const input = document.getElementById("selling-plan-input");
    if (input) input.value = plan;
    const buyAdd = document.getElementById("buy-add");
    if (buyAdd) {
      if (plan) buyAdd.dataset.sellingPlan = plan;
      else delete buyAdd.dataset.sellingPlan;
    }
  }

  function updateAddTotal() {
    const activeSwatch = document.querySelector("#swatches .swatch.is-active");
    const t = $("#buy-add-total");
    if (t && activeSwatch && activeSwatch.dataset.price) t.textContent = activeSwatch.dataset.price;
    const q = $("#q-val"); if (q) q.textContent = qty;
  }

  root.addEventListener("click", (e) => {
    const pickCard = e.target.closest(".pseg__opt");
    if (pickCard) { setPurchaseMode(pickCard); return; }
    
    const th = e.target.closest("[data-thumb]");
    if (th) {
      const track = $("#gallery-track");
      const idx = parseInt(th.dataset.index, 10);
      if (track && !isNaN(idx) && track.children[idx]) {
        track.children[idx].scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" });
      } else {
        const img = $("#gallery-img");
        if (img) {
          img.style.opacity = 0;
          setTimeout(() => {
            const restore = () => { img.style.opacity = 1; };
            img.addEventListener("load", restore, { once: true });
            img.addEventListener("error", restore, { once: true });
            img.src = th.dataset.thumb;
            // Falls das Bild gecacht ist und load nicht feuert: sofort & als Netz.
            if (img.complete) restore();
            setTimeout(restore, 600);
          }, 130);
        }
      }
      document.querySelectorAll("[data-thumb]").forEach((t) => t.classList.toggle("is-active", t === th));
      return;
    }
    
    const sw = e.target.closest("[data-sw]");
    if (sw) {
      document.querySelectorAll("[data-sw]").forEach((t) => t.classList.toggle("is-active", t === sw));
      const optName = $("#opt-name"); if (optName) optName.textContent = sw.dataset.name || "";
      const stickyName = $("#sticky-name"); if (stickyName) stickyName.textContent = sw.dataset.name || "";
      const stickyPrice = $("#sticky-price"); if (stickyPrice) stickyPrice.textContent = sw.dataset.price || "";
      const buyAdd = $("#buy-add");
      if (buyAdd) {
        buyAdd.dataset.variant = sw.dataset.sw;
        buyAdd.dataset.name = sw.dataset.name || "";
      }
      updateAddTotal();
      return;
    }
    if (e.target.closest("#q-inc")) { qty++; updateAddTotal(); return; }
    if (e.target.closest("#q-dec")) { qty = Math.max(1, qty - 1); updateAddTotal(); return; }
    
    const buyAdd = e.target.closest("#buy-add");
    if (buyAdd) {
      addItem(buyAdd.dataset.variant, buyAdd.dataset.name, qty, currentSellingPlan());
      qty = 1; updateAddTotal(); return;
    }
  });

  const stickyAdd = $("#sticky-add");
  if (stickyAdd) {
    stickyAdd.addEventListener("click", () => {
      const buyAdd = $("#buy-add");
      const variantId = buyAdd && buyAdd.dataset.variant;
      addItem(variantId, buyAdd && buyAdd.dataset.name, qty, currentSellingPlan());
      qty = 1; updateAddTotal();
    });
  }

  const fl = $("#faq-list");
  if (fl) {
    fl.addEventListener("click", (e) => {
      const q = e.target.closest(".faq__q"); if (!q) return;
      const item = q.closest(".faq__item");
      const a = item.querySelector(".faq__a");
      const open = item.classList.toggle("is-open");
      a.style.maxHeight = open ? a.scrollHeight + "px" : "0px";
    });
  }

  const sticky = $("#pdp-sticky"), anchor = $(".buy__row");
  if (sticky && anchor && "IntersectionObserver" in window) {
    const io = new IntersectionObserver(([en]) => {
      sticky.classList.toggle("is-visible", !en.isIntersecting && window.innerWidth < 1040);
      document.documentElement.style.setProperty("--sticky-h", sticky.classList.contains("is-visible") ? sticky.offsetHeight + "px" : "0px");
    }, { rootMargin: "0px 0px -40px 0px" });
    io.observe(anchor);
  }

  const galTrack = $("#gallery-track");
  if (galTrack) {
    const setActive = (idx) => {
      document.querySelectorAll(".gthumb").forEach((t) =>
        t.classList.toggle("is-active", parseInt(t.dataset.index, 10) === idx)
      );
    };
    let scrollT;
    galTrack.addEventListener("scroll", () => {
      clearTimeout(scrollT);
      scrollT = setTimeout(() => {
        const idx = Math.round(galTrack.scrollLeft / galTrack.clientWidth);
        setActive(idx);
      }, 60);
    });
    
    let down = false, startX = 0, startScroll = 0, moved = false;
    const main = galTrack.closest(".gallery__main");
    galTrack.addEventListener("pointerdown", (e) => {
      if (e.pointerType === "mouse") {
        down = true; moved = false;
        startX = e.clientX; startScroll = galTrack.scrollLeft;
        if (main) main.classList.add("is-grabbing");
      }
    });
    galTrack.addEventListener("pointermove", (e) => {
      if (!down) return;
      const dx = e.clientX - startX;
      // erst ab spürbarer Bewegung als "Drag" werten (vorher: 3px = zu empfindlich,
      // killte normale Klicks). 10px unterscheidet Tap zuverlässig von Drag.
      if (Math.abs(dx) > 10) moved = true;
      galTrack.scrollLeft = startScroll - dx;
    });
    const endDrag = () => {
      if (!down) return;
      down = false;
      if (main) main.classList.remove("is-grabbing");
      const idx = Math.round(galTrack.scrollLeft / galTrack.clientWidth);
      if (galTrack.children[idx]) {
        galTrack.children[idx].scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" });
      }
    };
    galTrack.addEventListener("pointerup", endDrag);
    galTrack.addEventListener("pointerleave", endDrag);
    galTrack.addEventListener("pointercancel", endDrag);
    // Nur einen echten Maus-DRAG abfangen — NICHT in der Capture-Phase und nur
    // wenn tatsächlich gezogen wurde. So bleiben Thumbnail-/Link-Klicks intakt.
    galTrack.addEventListener("click", (e) => {
      if (moved) { e.preventDefault(); moved = false; }
    }, false);
  }

  // ---- Wirkung-Section: Zahlen zählen hoch, sobald sie sichtbar werden ----
  const impactNums = document.querySelectorAll("#impact-grid .impact__num");
  if (impactNums.length && "IntersectionObserver" in window) {
    const easeOut = (t) => 1 - Math.pow(1 - t, 3);
    const runCount = (el) => {
      const valEl = el.querySelector(".impact__val");
      if (!valEl || el.dataset.counted === "1") return;
      el.dataset.counted = "1";
      const to = parseFloat(String(el.dataset.countTo).replace(",", "."));
      const decimals = parseInt(el.dataset.countDecimals, 10) || 0;
      if (isNaN(to)) { valEl.textContent = el.dataset.countTo || ""; return; }
      const dur = 1400; const start = performance.now();
      const tick = (now) => {
        const p = Math.min(1, (now - start) / dur);
        const cur = to * easeOut(p);
        valEl.textContent = cur.toFixed(decimals).replace(".", ",");
        if (p < 1) requestAnimationFrame(tick);
        else valEl.textContent = to.toFixed(decimals).replace(".", ",");
      };
      requestAnimationFrame(tick);
    };
    const io = new IntersectionObserver((entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) { runCount(entry.target); obs.unobserve(entry.target); }
      });
    }, { threshold: 0.4 });
    impactNums.forEach((n) => io.observe(n));
  }

  // ---- Ablauf-Section (3 Sekunden): Schritte erscheinen nacheinander ----
  const howSteps = document.querySelectorAll("#how-steps .how__step");
  if (howSteps.length && "IntersectionObserver" in window) {
    const howIo = new IntersectionObserver((entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) { entry.target.classList.add("is-in"); obs.unobserve(entry.target); }
      });
    }, { threshold: 0.3 });
    howSteps.forEach((s) => howIo.observe(s));
  } else {
    // Fallback ohne Observer: direkt sichtbar
    howSteps.forEach((s) => s.classList.add("is-in"));
  }

  // ---- Clean-Beauty-Section: Karten beim Scrollen einblenden ----
  const cleanCards = document.querySelectorAll("#clean-grid .clean__card");
  if (cleanCards.length && "IntersectionObserver" in window) {
    const cleanIo = new IntersectionObserver((entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) { entry.target.classList.add("is-in"); obs.unobserve(entry.target); }
      });
    }, { threshold: 0.25 });
    cleanCards.forEach((c) => cleanIo.observe(c));
  } else {
    cleanCards.forEach((c) => c.classList.add("is-in"));
  }

  // ---- Produkt-Anatomie: Labels nacheinander einblenden ----
  const anatomyPoints = document.querySelectorAll("#anatomy-stage .anatomy__point");
  if (anatomyPoints.length && "IntersectionObserver" in window) {
    const anatomyIo = new IntersectionObserver((entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) { entry.target.classList.add("is-in"); obs.unobserve(entry.target); }
      });
    }, { threshold: 0.2 });
    anatomyPoints.forEach((pt) => anatomyIo.observe(pt));
  } else {
    anatomyPoints.forEach((pt) => pt.classList.add("is-in"));
  }

  updateAddTotal();
}

function initBundlePage() {
  const grid = $("#mm-grid");
  if (!grid) return;
  const sel = new Set();
  const fill = $("#mm-fill"), status = $("#mm-status");
  const m5 = $("#mm-mile-5"), m8 = $("#mm-mile-8");
  const bar = $("#mm-bar"), barThumbs = $("#mm-bar-thumbs"), barCount = $("#mm-bar-count"), barPrice = $("#mm-bar-price"), addBtn = $("#mm-add");
  const stickyWrap = $("#mm-sticky"), stickyFill = $("#mm-sticky-fill"), stickyStatus = $("#mm-sticky-status"), stickyCount = $("#mm-sticky-count");
  const progressEl = document.querySelector(".mm__progress");

  function update(justReached) {
    const n = sel.size;
    if (fill) fill.style.width = Math.min(100, (n / 5) * 100) + "%";
    const m5on = n >= 3, m8on = n >= 5;
    if (m5) m5.classList.toggle("is-reached", m5on);
    if (m8) m8.classList.toggle("is-reached", m8on);
    
    let statusHTML;
    if (n === 0) statusHTML = "stell dir deine kuschel-familie zusammen.";
    else if (n < 2) statusHTML = `noch <strong>1</strong> Bärli bis 20% Rabatt.`;
    else if (n < 3) statusHTML = `noch <strong>1</strong> Bärli bis zum gratis Outfit.`;
    else if (n < 4) statusHTML = `noch <strong>1</strong> Bärli bis 30% Rabatt.`;
    else if (n < 5) statusHTML = `noch <strong>1</strong> Bärli bis zum gratis Teddy.`;
    else statusHTML = `<strong>alles freigeschaltet</strong> 🧸`;
    if (status) status.innerHTML = statusHTML;
    
    if (stickyFill) stickyFill.style.width = Math.min(100, (n / 5) * 100) + "%";
    if (stickyStatus) {
      stickyStatus.innerHTML = n === 0 ? "stell dir dein set zusammen"
        : n < 2 ? `noch <strong>1</strong> bis 20% Rabatt`
        : n < 3 ? `noch <strong>1</strong> bis Outfit`
        : n < 4 ? `noch <strong>1</strong> bis 30% Rabatt`
        : n < 5 ? `noch <strong>1</strong> bis gratis Teddy`
        : `<strong>alles freigeschaltet 🧸</strong>`;
    }
    if (stickyCount) stickyCount.textContent = `${n} / 5`;
    
    if (barThumbs) {
      const ids = [...sel];
      const shown = ids.slice(0, 4);
      const extra = ids.length - shown.length;
      let html = shown.map((id) => {
        const card = grid.querySelector(`[data-pick="${id}"]`);
        const imgSrc = card ? card.dataset.img : "";
        return `<span class="mm-bar__thumb"><img src="${imgSrc || ""}" alt=""></span>`;
      }).join("");
      if (extra > 0) html += `<span class="mm-bar__thumb mm-bar__thumb--more">+${extra}</span>`;
      barThumbs.innerHTML = html;
    }
    
    if (barCount) barCount.textContent = n === 0 ? "noch keine bärlis gewählt" : `${n} ${n === 1 ? "bärli" : "bärlis"} gewählt`;
    if (barPrice) barPrice.innerHTML = "";
    if (addBtn) addBtn.disabled = n === 0;
    if (bar) bar.classList.toggle("is-active", n > 0);
    if (justReached && (justReached === 3 || justReached === 5)) { popEl(justReached === 5 ? m8 : m5); }
  }

  grid.addEventListener("click", (e) => {
    const btn = e.target.closest("[data-pick]");
    if (!btn) return;
    const id = btn.dataset.pick;
    let reached = 0;
    if (sel.has(id)) { sel.delete(id); }
    else { sel.add(id); if (sel.size === 3 || sel.size === 5) reached = sel.size; }
    btn.classList.toggle("is-picked", sel.has(id));
    btn.setAttribute("aria-pressed", sel.has(id) ? "true" : "false");
    update(reached);
  });

  if (addBtn) addBtn.addEventListener("click", () => {
    if (!sel.size) return;
    addBtn.disabled = true;
    const picked = [...sel];
    openCart();
    queueCartOp(async () => {
      try {
        for (const id of picked) await cartAdd(id, 1);
        await syncCartFromShopify();
        showToast(`${picked.length} bärlis ins set gelegt ♥`);
        sel.clear();
        grid.querySelectorAll("[data-pick].is-picked").forEach((b) => { b.classList.remove("is-picked"); b.setAttribute("aria-pressed", "false"); });
        update(0);
      } catch (err) {
        console.error("gloofy bundle add error:", err);
        showToast("set konnte nicht hinzugefügt werden");
      } finally {
        addBtn.disabled = sel.size === 0;
      }
    });
  });

  if (stickyWrap && progressEl && "IntersectionObserver" in window) {
    const io = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const scrolledPast = !entry.isIntersecting && entry.boundingClientRect.top < 0;
        stickyWrap.classList.toggle("is-visible", scrolledPast);
      });
    }, { threshold: 0 });
    io.observe(progressEl);
  }
  update(0);
}

function addToCartSilent(id, name) {
  return cartAdd(id, 1);
}

function initScentQuiz() {
  const stage = document.getElementById("quiz-stage");
  if (!stage) return;
  const steps = Array.from(stage.querySelectorAll(".quiz__step"));
  const resultWrap = stage.querySelector(".quiz__result");
  const bar = stage.querySelector("#quiz-bar");
  const totalQ = steps.length;
  let current = 0;
  const scores = {};

  function showStep(idx) {
    steps.forEach((s, i) => s.classList.toggle("is-active", i === idx));
    resultWrap.classList.remove("is-active");
    if (bar) bar.style.width = ((idx) / totalQ * 100) + "%";
  }

  function tally(answerId) {
    // answerId z.B. "q1a" -> data-q1a enthält den Schlüssel
    const key = stage.dataset[answerId];
    if (key) scores[key] = (scores[key] || 0) + 1;
  }

  function showResult() {
    if (bar) bar.style.width = "100%";
    // Gewinner-Schlüssel ermitteln (erstes Maximum)
    let winner = null, max = -1;
    Object.keys(scores).forEach((k) => { if (scores[k] > max) { max = scores[k]; winner = k; } });
    steps.forEach((s) => s.classList.remove("is-active"));
    resultWrap.classList.add("is-active");
    const cards = resultWrap.querySelectorAll(".quiz__result-card");
    let shown = false;
    cards.forEach((c) => {
      const match = c.dataset.result === winner;
      c.classList.toggle("is-shown", match);
      if (match) shown = true;
    });
    // Fallback: erste Karte zeigen, falls kein Treffer
    if (!shown && cards.length) cards[0].classList.add("is-shown");
  }

  stage.querySelectorAll(".quiz__opt").forEach((btn) => {
    btn.addEventListener("click", () => {
      tally(btn.dataset.answer);
      current++;
      if (current >= totalQ) showResult();
      else showStep(current);
    });
  });

  const restart = stage.querySelector("#quiz-restart");
  if (restart) restart.addEventListener("click", () => {
    current = 0;
    Object.keys(scores).forEach((k) => delete scores[k]);
    resultWrap.querySelectorAll(".quiz__result-card").forEach((c) => c.classList.remove("is-shown"));
    showStep(0);
  });

  showStep(0);
}

function initRetailReveal() {
  const els = document.querySelectorAll("#retail-media, #retail-content");
  if (!els.length) return;
  if ("IntersectionObserver" in window) {
    const io = new IntersectionObserver((entries, obs) => {
      entries.forEach((e) => { if (e.isIntersecting) { e.target.classList.add("is-in"); obs.unobserve(e.target); } });
    }, { threshold: 0.2 });
    els.forEach((el) => io.observe(el));
  } else {
    els.forEach((el) => el.classList.add("is-in"));
  }
}

function initRoutine() {
  const routineSteps = document.querySelectorAll("#routine-steps .routine__step");
  const routineSlides = document.querySelectorAll(".routine__stage .routine__slide");
  if (!routineSteps.length || !routineSlides.length) return;
  const activateRoutine = (idx) => {
    routineSteps.forEach((s) => {
      const on = s.dataset.routineIndex === String(idx);
      s.classList.toggle("is-active", on);
      s.setAttribute("aria-selected", on ? "true" : "false");
    });
    routineSlides.forEach((sl) => {
      sl.classList.toggle("is-active", sl.dataset.routineSlide === String(idx));
    });
  };
  routineSteps.forEach((s) => {
    s.addEventListener("click", () => activateRoutine(s.dataset.routineIndex));
    s.addEventListener("mouseenter", () => activateRoutine(s.dataset.routineIndex));
  });
}

function __gloofyInit() {
  renderBenefits();
  readBundleConfig();
  syncCartFromShopify();
  startCountdown();
  setupDrawer();
  setupStickyCta();
  setupCartStickyProgress();
  initProductPage();
  initBundlePage();
  initScentQuiz();
  initRetailReveal();
  initRoutine();
  bindEvents();
}

if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", __gloofyInit);
else __gloofyInit();

/* -------------------------------------------------------------------------
   Shopify Theme 2.0 — Re-Init bei Section-Render im Theme-Editor.
   Wird die Produkt-/Bundle-/Quiz-Sektion neu gerendert, ersetzt Shopify deren
   DOM; die alten Event-Listener hängen dann an entfernten Knoten. Wir binden
   die betroffenen Init-Funktionen für die neu eingefügte Sektion erneut.
   ------------------------------------------------------------------------- */
function __gloofyReinit(scope) {
  try {
    // Nur die Funktionen erneut aufrufen, die DOM-gebundene Listener setzen.
    if (scope && scope.querySelector) {
      if (scope.querySelector(".pdp, .pdp__top")) initProductPage();
      if (typeof initBundlePage === "function" && scope.querySelector("[data-bundle], .bundlebuilder, #bundle")) initBundlePage();
      if (typeof initScentQuiz === "function" && scope.querySelector(".scent-quiz, #scent-quiz")) initScentQuiz();
      if (typeof initRetailReveal === "function") initRetailReveal();
      if (typeof initRoutine === "function") initRoutine();
    }
    if (typeof setupStickyCta === "function") setupStickyCta();
    if (typeof renderBenefits === "function") renderBenefits();
  } catch (err) { /* defensiv: Editor-Re-Render darf nie crashen */ }
}

document.addEventListener("shopify:section:load", function (e) {
  __gloofyReinit(e.target || document);
});
document.addEventListener("shopify:section:select", function (e) {
  __gloofyReinit(e.target || document);
});